import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes }   from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MarkdownToHtmlModule } from 'ng2-markdown-to-html';

import { ContentfulService } from './contentful.service';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ProjectComponent } from './project/project.component';
import { SafePipe } from './safepipe.component';
import { ImageLoaderDirective } from './directive/image-loader.directive';

// define the available routes
const routes: Routes = [
  { path: '', redirectTo: '/projects', pathMatch: 'full' },
  { path: 'projects',  component: HomeComponent, data: { state: 'projects' } },
  { path: 'about',  component: AboutComponent, data: { state: 'about' } },
  { path: 'project/:id',  component: ProjectComponent, data: { state: 'project' } }
];


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ProjectComponent,
    SafePipe,
    ImageLoaderDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(
      routes,
      { enableTracing: false } // <-- debugging purposes only
    ),
    MarkdownToHtmlModule.forRoot()
    // other imports here
  ],
  providers: [
    ContentfulService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}



// WEBPACK FOOTER //
// C:/Users/timva/Documents/Work/LatestDownload/src/app/app.module.ts